import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import { InPageNotification } from "@ebsco-ui/ebsco-ui";
import { scrollToRef } from "../../utils/dom-utils";

import "./form-error-notification.scss";

const FormErrorNotification = ({
  className,
  headerMessage,
  descriptionMessage,
  scrollToOnMount = true
}) => {
  const errorNotificationRef = React.useRef();

  React.useEffect(() => {
    if (scrollToOnMount) {
      scrollToRef(errorNotificationRef);
      errorNotificationRef.current.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      ref={errorNotificationRef}
      aria-live="polite"
      className={cn(className, "form-error-notification")}
      tabIndex="-1"
    >
      <InPageNotification variant="error">
        <InPageNotification.Header>{headerMessage}</InPageNotification.Header>
        <InPageNotification.Description>
          {descriptionMessage}
        </InPageNotification.Description>
      </InPageNotification>
    </div>
  );
};

FormErrorNotification.propTypes = {
  className: PropTypes.string,
  headerMessage: PropTypes.string.isRequired,
  descriptionMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    .isRequired
};

FormErrorNotification.defaultProps = {
  className: ""
};

export default FormErrorNotification;
